import { createFileRoute, Outlet } from "@tanstack/react-router";
import Footer from "@/components/Footer";
import Header from "@/components/Header";

export const Route = createFileRoute("/_pages")({
	component: Marketing,
});

function Marketing() {
	return (
		<div className="isolate flex min-h-dvh flex-col">
			<Header />
			<div className="flex-1">
				<Outlet />
			</div>
			<Footer />
		</div>
	);
}
